import { EditMode, ProfileTab } from "@/Common/Models/Patient/PatientEnums";
import { PortalRegistrationState } from "@/Common/Models/Portal/Enums/PortalRegistrationState";
import { Relative } from "../Models/Relative";
import { RelativeFileUIModel } from "../Models/UI/RelativeFileUIModel";
import { relativeStore } from "../Stores/RelativeStore";
import { ContactsEdit } from "./ContactsEdit";
import { ContactsView } from "./ContactsView";
import { DemographicEdit } from "./DemographicEdit";
import { DemographicView } from "./DemographicView";
import { IdentifiersEdit } from "./IdentifiersEdit";
import { IdentifiersView } from "./IdentifiersView";
import { Relations } from "./Relations";

import "./ProfileView.css";

interface IProfileViewProps {
    relative: Relative;
    model: RelativeFileUIModel;
}

class ProfileView extends React.Component<IProfileViewProps, any> {
    public render(): JSX.Element {
        const relative = this.props.relative;
        const file = this.props.model;

        const showPortalTab =
            cacheStore.ClinicSettings_Portal.EnablePortalV2
            && relative
            && (
                relative.PortalSyncState === PortalRegistrationState.RegistrationComplete
                || relative.PortalSyncState === PortalRegistrationState.RegistrationPending
                || relative.PortalSyncState === PortalRegistrationState.ChildAccount
            );

        return (
            <div className="profileView">
                <div className="patient-subtabs">
                    <ul>
                        {this.buildProfileTab(file, ProfileTab.Demographic, "DemographicLabel")}
                        {this.buildProfileTab(file, ProfileTab.Identifiers, "IdentifiersLabel")}
                        {this.buildProfileTab(file, ProfileTab.Contacts, "ContactsLabel")}
                        {this.buildProfileTab(file, ProfileTab.Relationships, "RelationsLabel")}
                        {showPortalTab &&
                            this.buildProfileTab(file, ProfileTab.PortalSubscription, "PortalLabel")
                        }
                    </ul>
                </div>
                <div className="profile-subtabs-container">
                    {this.switchTabComponents(file)}
                </div>
            </div>
        );
    }

    private buildProfileTab(file: RelativeFileUIModel, tab: ProfileTab, labelKey: string): JSX.Element {
        const css = file.ActiveTab === tab ? "active" : null;
        return (
            <li className={css} data-cy={`patientProfile-tab${ProfileTab[tab]}`}>
                <a onClick={() => this.onTabClick(tab)}>
                    {cacheStore.GetString(labelKey)}
                </a>
            </li>
        );
    }

    private onTabClick(tab: ProfileTab): void {
        relativeStore.actions.switchTab(tab, false);
    }

    private switchTabComponents(file: RelativeFileUIModel): JSX.Element {
        switch (file.ActiveTab) {
            case ProfileTab.Demographic:
            {
                return file.isEditing
                    ? <DemographicEdit />
                    : <DemographicView />;
            }
            case ProfileTab.Identifiers:
            {
                return file.isEditing
                    ? <IdentifiersEdit />
                    : <IdentifiersView />;
            }
            case ProfileTab.Contacts:
            {
                return file.isEditing
                    ? <ContactsEdit />
                    : <ContactsView />;
            }
            case ProfileTab.Relationships:
                return <Relations view={file.isEditing ? EditMode.Edit : EditMode.View} />;
            default:
                throw new Error("The tab is not implemented.");
        }
    }
}

export { ProfileView };
